import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Business } from '../models/business.model';
import { QuickNavToc } from '../../shared/models/quick-nav-toc.model';
import { BusinessFuelComponent } from '../business-fuel/business-fuel.component';
import { BusinessAmenitiesComponent } from '../business-amenities/business-amenities.component';
import { BusinessSalesComponent } from '../business-sales/business-sales.component';
import { BusinessMaintenanceComponent } from '../business-maintenance/business-maintenance.component';
import { RentalsComponent } from '../rentals/rentals.component';
import { TrainingComponent } from '../training/training.component';
import { EducationalInfoComponent } from '../educational-info/educational-info.component';
import { FeesSectionComponent } from '../fees-section/fees-section.component';
import { RentalCarsComponent } from '../../shared/rental-cars/rental-cars.component';
import { QuickNavComponent } from '../../shared/quick-nav/quick-nav.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { BusinessDescriptionComponent } from '../business-description/business-description.component';
import { AirportService } from '../../airport/airport.service';
import { getFteAwardTags, hasTag } from '../../util/tag-utils';
import { WhatsnewComponent } from '../../whatsnew/whatsnew.component';
import { MatDialog } from '@angular/material';
import { WhatsNewService } from '../../shared/services/whats-new.service';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { AuthService } from '../../auth/auth/auth.service';
var BusinessDetailComponent = /** @class */ (function () {
    function BusinessDetailComponent(_route, _errorHandler, businessManagerService, _toggleService, _airportService, _matDialog, _whatsNewService, _analyticsService, _auth) {
        var _this = this;
        this._route = _route;
        this._errorHandler = _errorHandler;
        this.businessManagerService = businessManagerService;
        this._toggleService = _toggleService;
        this._airportService = _airportService;
        this._matDialog = _matDialog;
        this._whatsNewService = _whatsNewService;
        this._analyticsService = _analyticsService;
        this._auth = _auth;
        this.isBusinessOwner = false;
        this.editModeSet = false;
        this.isFlightDeckAdmin = false;
        this.isRegionalManager = false;
        this.isFbo = false;
        this.isFlightSchool = false;
        this.displayHistoricalBadges = false;
        this.displayReportCard = false;
        this.awardTags = [];
        this.isDoneInit = false;
        this.isNotApproved = false;
        this.toc = new QuickNavToc('fbo-quicknav', [{
                label: 'Overview',
                fragment: 'overview',
                visible: true
            }, {
                label: 'Contact Info',
                fragment: 'contacts',
                visible: true
            }, {
                label: 'Business Description',
                fragment: 'desc',
                visible: function () { return _this.businessDescriptionSection.hasContent; }
            }, {
                label: 'Fuel Prices',
                fragment: 'fuel',
                visible: function () { return _this.businessFuelSection.hasContent; }
            }, {
                label: 'Fees',
                fragment: 'fees',
                visible: function () { return _this.feesSection.hasContent; }
            }, {
                label: 'Services',
                fragment: 'services',
                visible: function () { return _this.servicesSection.hasContent; }
            }, {
                label: 'Rental Agency',
                fragment: 'rental-agency',
                visible: function () { return _this.rentalCarsSection.hasContent; }
            }, {
                label: 'Sales',
                fragment: 'sales',
                visible: function () { return _this.salesSection.hasContent; }
            }, {
                label: 'Maintenance',
                fragment: 'maintenance',
                visible: function () { return _this.maintenanceSection.hasContent; }
            }, {
                label: 'Rentals',
                fragment: 'rentals',
                visible: function () { return _this.rentalsSection.hasContent; }
            }, {
                label: 'Educational Info',
                fragment: 'edu',
                visible: function () { return _this.eduSection.hasContent; }
            }, {
                label: 'Flight Training',
                fragment: 'training',
                visible: function () { return _this.trainingSection.hasContent; }
            }]);
    }
    Object.defineProperty(BusinessDetailComponent.prototype, "faaIdent", {
        get: function () {
            if (this.business.airports && this.business.airports.length > 0) {
                return this.business.airports[0].faaId;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    BusinessDetailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, showWhatsNew, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this._route.data
                            .subscribe(function (data) {
                            _this.business = data.business;
                        }, function (error) {
                            _this._errorHandler.handleError(error);
                        });
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.userOwnsBusiness(this.business.id)];
                    case 1:
                        _a.isBusinessOwner = _e.sent();
                        _b = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 2:
                        _b.isFlightDeckAdmin = _e.sent();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _c = this;
                        return [4 /*yield*/, this.businessManagerService.isRegionalManager()];
                    case 3:
                        _d = (_e.sent());
                        if (!_d) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.businessManagerService.userOwnsBusiness(this.business.id)];
                    case 4:
                        _d = !(_e.sent());
                        _e.label = 5;
                    case 5:
                        _c.isRegionalManager = _d;
                        this.isFbo = hasTag(this.business.tags, 'Admin::BusinessIsFbo');
                        this.isFlightSchool = (!this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training::Private'); })
                            && this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training'); }));
                        this.displayHistoricalBadges = hasTag(this.business.tags, 'Admin::Flight Training::Display Prior Year Badges');
                        this.displayReportCard = hasTag(this.business.tags, 'Admin::Flight Training::Display Customer Feedback Report');
                        this.awardTags = getFteAwardTags(this.business.tags);
                        this.isNotApproved = hasTag(this.business.tags, 'Admin::BusinessNotApproved');
                        return [4 /*yield*/, this._whatsNewService.shouldShowWhatsNew()];
                    case 6:
                        showWhatsNew = _e.sent();
                        if (showWhatsNew) {
                            dialogRef = this._matDialog.open(WhatsnewComponent);
                            dialogRef.afterClosed().subscribe(function (result) {
                                _this._whatsNewService.displayedWhatsNew();
                            });
                        }
                        this.isDoneInit = true;
                        this._analyticsService.pageView('airport_business', 'Business Detail');
                        this._analyticsService.trackEvent('airport_business_viewed', this.business.id.toString(), this.business.id.toString());
                        if (this._auth.authenticated && this._auth.endUser) {
                            this._analyticsService.trackEvent('airport_business_loggedin', this._auth.recid, this._auth.recid);
                        }
                        else {
                            this._analyticsService.trackEvent('airport_business_loggedout', '', '');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessDetailComponent.prototype.onReloadBusiness = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 1:
                        _a.business = _b.sent();
                        this.displayHistoricalBadges = hasTag(this.business.tags, 'Admin::Flight Training::Display Prior Year Badges');
                        this.awardTags = getFteAwardTags(this.business.tags);
                        this.displayReportCard = hasTag(this.business.tags, 'Admin::Flight Training::Display Customer Feedback Report');
                        this.isNotApproved = hasTag(this.business.tags, 'Admin::BusinessNotApproved');
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessDetailComponent.prototype.ngAfterViewInit = function () {
        /*
        const $detailBody = $(this.body.nativeElement);
        const $page = $detailBody.closest('.detail-page');
        this.quicknav.setContainerHeight($page.height() + 1000);
        */
        if (hasTag(this.business.tags, 'Admin::BusinessNotApproved')) {
            this.showHelp();
        }
    };
    BusinessDetailComponent.prototype.showHelp = function () {
        var businessType = 'Business';
        if (hasTag(this.business.tags, 'Admin::BusinessIsFbo')) {
            businessType = 'FBO';
        }
        else if ((!this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training::Private'); })
            && this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training'); }))) {
            businessType = 'Flight School';
        }
        var dialogRef = this._matDialog.open(HelpDialogComponent, {
            data: {
                businessType: businessType
            }
        });
    };
    return BusinessDetailComponent;
}());
export { BusinessDetailComponent };
